import { makeStyles } from '@mui/styles';
import React, { useState, useEffect } from 'react';
import GenericButton from '../../components/updated/shared/Button';
import CustomSelectBox from '../../components/updated/Deposit/CustomSelect';
import InputField from '../../components/updated/shared/TextField';
import { InputAdornment, useTheme } from '@mui/material';
import WithdrawCryptoLayout from '../../components/updated/WithdrawCrypto';
import inexLogo from '../../assets/updated/buySell/INEX-sm.svg';
import initialTokens from '../../utils/Tokens.json';
import {
  decodeJWT,
  transactionList,
  getUserWallets,
  getMinAndMaxOrderValues,
  createCryptoWithdraw,
  validateUserEmail,
  getCoinPriceByName,
} from '../../services/api';
import useCopyToClipboard from '../../utils/useCopyToClipboard';
import { Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import ShortenText from '../../utils/ShortenText';
import { Table } from 'antd';
import Web3 from 'web3';
import GeneralPopup from '../../components/updated/BuySell/Popup';
import { isTokenVisibleOnBuySell } from '../../utils/tokenVisibility';
const web3 = new Web3(Web3.givenProvider || 'http://localhost:8545');

const { Text } = Typography;

const useStyle = makeStyles((theme) => ({
  enterAmountRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'stretch',
    justifyContent: 'stretch',
  },
  heading: {
    fontSize: '30px',
    fontWeight: '600',
    color: `${theme.palette.text.primary} !important`,
    textAlign: 'left',
  },
  secHeading: {
    fontSize: '24px',
    fontWeight: '600',
    color: `${theme.palette.text.primary} !important`,
    marginBottom: theme.spacing(2),
  },
  label: {
    color: `${theme.palette.text.primary} !important`,
    fontSize: '14px',
    margin: '15px 0px',
  },
  depositContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    display: 'flex',
    gap: '10px',
    padding: '20px 15px',
    alignItems: 'center',
    width: '100%',
    '& h6': {
      fontSize: '16px',
      color: `${theme.palette.text.primary} !important`,
    },
    '& p': {
      fontSize: '12px',
      color: `${theme.palette.text.secondary} !important`,
    },
  },
  text: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(3),
  },
  gridContainer: {
    marginBottom: theme.spacing(2),
    margin: '15px 0px',
  },
  gridItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  gridHeading: {},
  gridText: {
    color: theme.palette.text.primary,
  },
  listItem: {
    fontSize: '15px',
    color: theme.palette.text.primary,
  },
  copyButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  endAdornmentContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '10px',
    borderLeft: `1px solid ${theme.palette.divider}`,
    '& img': {
      width: '25px',
      height: '25px',
    },
  },
  selectBox: {
    width: '100%',
    height: '55px',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.mode === 'light' ? '#fff' : '#1e2329',
    color: `${theme.palette.text.primary} !important`,
    padding: '0 12px',
    fontSize: '16px',
  },
  feeDisclaimer: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    marginBottom: '10px',
  },
}));

const WithdrawCryptoSelectCoin = () => {
  const classes = useStyle();
  const theme = useTheme();
  const [showWarning, setShowWarning] = useState(false);
  const [network, setNetwork] = useState('');
  const [value, setValue] = useState('funding');
  const [txList, setTxList] = useState([]);
  const [usersWallets, setUsersWallets] = useState([]);
  const [coinNetwork, setCoinNetwork] = useState('');
  const [singleWallet, setSingleWallet] = useState(null);
  const [selectedCoin, setSelectedCoin] = useState('INEX');
  const [usdtNetwork, setUsdtNetwork] = useState('Ethereum');
  const [receiveAmountt, setReceiveAmount] = useState('');
  const [selectedCoinObj, setSelectedCoinObj] = useState({});
  const [isWalletAddrValid, setIsWalletAddrValid] = useState(true);
  const [, copy] = useCopyToClipboard();
  const [loadings, setLoadings] = useState(false);
  const [values, setValues] = useState({});
  const [finalAmount, setFinalAmount] = useState('');
  const [walletAddress, setWalletAddre] = useState('');
  const [email, setEmail] = useState('');
  const [popupMessage, setPopupMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const decodedToken = decodeJWT(String(token));
    setEmail(decodedToken.email);
    transactionList(decodedToken?.email).then((res) => {
      const finalArr = res.data.filter(
        (x) => x.transactionType === 'WITHDRAW_CYRPTO'
      );
      setTxList(finalArr);
    });
    getUserWallets(decodedToken?.email).then((res) => {
      setUsersWallets(res.data);
      const userWallet = res.data.find((x) => x.coinSymbol === 'INEX');
      setSingleWallet(userWallet);
      setSelectedCoinObj(initialTokens.find((token) => token.title === 'INEX'));
      setCoinNetwork(userWallet?.coinNetwork);
      getMinAndMaxOrderValues('INEX', 'WITHDRAW_CRYPTO').then((res) => {
        setValues(res);
      });
    });
  }, []);

  const USDT_NETWORK_OPTIONS = [
    'Ethereum',
    'Solana',
    'Binance Smart Chain',
  ];

  const NETWORK_FEE_MAP = {
    Ethereum: '0.0005',
    Solana: '0.00001',
    'Binance Smart Chain': '0.0003',
    'Ying Yang Chain': '0.0005',
    default: '0.0005',
  };
  const WITHDRAWAL_FEE_PERCENT = 0.03;

  const categorizeTokens = (tokens) => {
    const visibleTokens = tokens.filter((token) => {
      if (String(token.title || '').toUpperCase() === 'BTCY') {
        return false;
      }
      return isTokenVisibleOnBuySell(token);
    });
    return {
      Stocks: visibleTokens.filter((token) => token.isStock),
      ETFs: visibleTokens.filter((token) => token.isETF),
      Cryptos: visibleTokens.filter(
        (token) => !token.isStock && !token.isETF
      ),
    };
  };

  const categorizedTokens = categorizeTokens(initialTokens);

  const findWalletForCoin = (coinTitle, network = '') => {
    const matches = usersWallets.filter((x) => x.coinSymbol === coinTitle);
    if (!matches.length) {
      return null;
    }
    if (network) {
      const exact = matches.find(
        (wallet) => wallet.coinNetwork === network || wallet.chain === network
      );
      if (exact) {
        return exact;
      }
    }
    return matches[0];
  };

  const handleUsdtNetworkChange = async (network) => {
    setUsdtNetwork(network);
    setCoinNetwork(network);
    const wallet = findWalletForCoin('USDT', network);
    setSingleWallet(wallet);
    if (selectedCoin === 'USDT') {
      const res = await getMinAndMaxOrderValues('USDT', 'WITHDRAW_CRYPTO');
      setValues(res);
    }
  };

  const getCurrentNetwork = () => {
    return selectedCoin === 'USDT'
      ? usdtNetwork
      : coinNetwork || singleWallet?.coinNetwork || '';
  };

  const getNetworkFeeValue = () => {
    const network = getCurrentNetwork();
    return NETWORK_FEE_MAP[network] || NETWORK_FEE_MAP.default;
  };

  const getRequestedAmount = () => {
    const amount = Number(receiveAmountt);
    return Number.isFinite(amount) ? amount : 0;
  };

  const getWalletBalance = () => {
    const balance = Number(singleWallet?.coinBalance || 0);
    return Number.isFinite(balance) ? balance : 0;
  };

  const calculateFinalAmount = (amount) => {
    if (!Number.isFinite(amount) || amount <= 0) {
      return '';
    }
    const networkFee = Number(getNetworkFeeValue()) || 0;
    const finalReceiveAmount = amount - amount * WITHDRAWAL_FEE_PERCENT - networkFee;
    return Math.max(finalReceiveAmount, 0);
  };

  useEffect(() => {
    setFinalAmount(calculateFinalAmount(getRequestedAmount()));
  }, [receiveAmountt, coinNetwork, usdtNetwork, selectedCoin]);

  const requestedAmount = getRequestedAmount();
  const walletBalance = getWalletBalance();
  const hasInsufficientBalance = requestedAmount > 0 && requestedAmount > walletBalance;

  const handleCurrencyChange = async (value) => {
    const getRequiredCoin = initialTokens.find((x) => x.title === value);
    const isUsdtCoin = getRequiredCoin?.title === 'USDT';
    const networkToUse = isUsdtCoin
      ? usdtNetwork
      : getRequiredCoin?.chain || '';
    const wallet = findWalletForCoin(getRequiredCoin?.title, networkToUse);
    console.log('getRequiredCoin', getRequiredCoin);
    setSelectedCoinObj(getRequiredCoin || {});
    setSelectedCoin(getRequiredCoin?.title || '');
    setSingleWallet(wallet);
    setCoinNetwork(networkToUse);
    if (isUsdtCoin && networkToUse) {
      setUsdtNetwork(networkToUse);
    }

    const res = await getMinAndMaxOrderValues(
      String(getRequiredCoin?.title),
      'WITHDRAW_CRYPTO'
    );
    setValues(res);
  };

  const onChangeReceiveAmt = (e) => {
    const val = e.currentTarget.value;
    setReceiveAmount(val + '');
    setNetwork('');
    setFinalAmount(calculateFinalAmount(Number(val)));
  };

  const onChageAdd = (e) => {
    const val = e.currentTarget.value;
    setWalletAddre(val);
    checkWalletAddress(val, selectedCoin);
  };

  const checkWalletAddress = async (address, currency) => {
    let isValid = false;

    if (currency === 'BTC') {
      // Regex for Bitcoin addresses (both legacy & SegWit formats)
      const btcRegex = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
      isValid = btcRegex.test(address);
    } else {
      // Validate Ethereum address
      isValid = web3.utils.isAddress(address);
    }

    setIsWalletAddrValid(isValid);
  };

  const withdrawCrypto = async () => {
    setLoadings(true);
    const requestAmount = getRequestedAmount();
    if (selectedCoin === 'BTCY') {
      setPopupMessage('BTCY withdrawal is not supported from this page.');
      setShowPopup(true);
      setLoadings(false);
      return;
    }
    if (!singleWallet) {
      setPopupMessage(`${selectedCoin} wallet not found.`);
      setShowPopup(true);
      setLoadings(false);
      return;
    }
    if (!Number.isFinite(requestAmount) || requestAmount <= 0) {
      setPopupMessage('Enter a valid withdrawal amount.');
      setShowPopup(true);
      setLoadings(false);
      return;
    }
    if (requestAmount > walletBalance) {
      setPopupMessage(
        `Insufficient ${selectedCoin} balance. Available balance is ${walletBalance}.`
      );
      setShowPopup(true);
      setLoadings(false);
      return;
    }
    const selectedCoinPrice = await getCoinPriceByName(selectedCoin);
    let usdAmount = requestAmount * selectedCoinPrice.data.results.data;
    if (usdAmount > 500) {
      // ask for KYC is the converted final amount is greater 500 usd
      const email = localStorage.getItem('email');
      const response = await validateUserEmail(email);
      const data = response;

      if (data.status === 200) {
        console.log('data', data);
        if (!data.data.isKYCPass && data.data.kycStatus !== 'Completed') {
          setShowPopup(true);
          setPopupMessage('Please Complete KYC first');
          setLoadings(false);
          return;
        }
      }
    }
    const res = await createCryptoWithdraw(
      email,
      requestAmount,
      walletAddress,
      selectedCoin,
      coinNetwork
    );
    if (res.status === 200) {
      const txs = await transactionList(email);
      const txHash = res?.data?.data?.hash;
      const successMessage = txHash
        ? 'Withdraw Successful. Transaction Id: ' + txHash
        : res?.data?.data?.message ||
          'Crypto withdrawal request recorded. We will follow up once the manual payout is ready.';
      setPopupMessage(successMessage);
      const finalArr = txs.data.filter(
        (x) => x.transactionType === 'WITHDRAW_CYRPTO'
      );
      setTxList(finalArr);
      setLoadings(false);
    } else {
      setLoadings(false);
      setPopupMessage(
        res?.data?.message ||
          'Failed to withdraw. Please try again or contact support'
      );
    }
    setShowPopup(true);
  };

  const getImage = (image) => {
    console.log('my image', image);
    try {
      return require(`../../assets/token-icons/${image}.png`).default;
    } catch (error) {
      return inexLogo; // Fallback image if specific token icon is not found
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false);
    setPopupMessage('');
  };

  return (
    <WithdrawCryptoLayout>
      <div className={classes.enterAmountRoot}>
        <h3 className={classes.heading}>1. Select Coin</h3>
        <h4 className={classes.label}>Coin</h4>
        <CustomSelectBox
          items={categorizedTokens.Cryptos.map((token) => token.title)}
          type={'Coin'}
          defaultValue={'INEX'}
          onCurrencyChange={handleCurrencyChange}
        />
        {selectedCoin === 'USDT' && (
          <>
            <h4 className={classes.label}>Blockchain</h4>
            <CustomSelectBox
              items={USDT_NETWORK_OPTIONS}
              type={'Select Network'}
              defaultValue={usdtNetwork}
              onCurrencyChange={handleUsdtNetworkChange}
            />
          </>
        )}
        <div style={{ margin: '10px' }}></div>

        <h3 className={classes.secHeading}>Send to</h3>
        <h4 className={classes.label}>Address</h4>
        <InputField
          type={'text'}
          placeholder="Enter address"
          style={{ height: '55px', margin: 0 }}
          onChange={onChageAdd}
        />
        {!isWalletAddrValid && (
          <Text style={{ color: theme.palette.text.primary }}>
            Invalid Wallet Address
          </Text>
        )}

        <h4 className={classes.label}>Amount</h4>
        <InputField
          type={'text'}
          placeholder="Enter Amount"
          style={{ height: '55px', margin: 0 }}
          value={receiveAmountt}
          onChange={onChangeReceiveAmt}
          endAdornment={
            <InputAdornment position="end">
              <span className={classes.endAdornmentContainer}>
                <img src={getImage(selectedCoin)} alt={'INEX'} />
                <p>{selectedCoin}</p>
              </span>
            </InputAdornment>
          }
        />

        <div container className={classes.gridContainer}>
          <div item xs={6} className={classes.gridItem}>
            <div>
              <p className={classes.gridHeading}>{selectedCoin} Balance</p>
              <p className={classes.gridText}>
                {singleWallet?.coinBalance} {selectedCoin}
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p className={classes.gridHeading}>Asset Wallet</p>
              <p className={classes.gridText}>{selectedCoin}</p>
            </div>
          </div>
          <div item xs={6} className={classes.gridItem}>
            <div>
              <p className={classes.gridHeading}>Minimum withdrawal</p>
              <p className={classes.gridText}>
                {values?.min} {selectedCoin}
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p className={classes.gridHeading}>Maximum withdrawal</p>
              <p className={classes.gridText}>
                {values?.max} {selectedCoin}
              </p>
            </div>
          </div>

          <div item xs={6} className={classes.gridItem}>
            <div>
              <p className={classes.gridHeading}>Network Fee</p>
          <p className={classes.gridText}>
                {getNetworkFeeValue()} {selectedCoin}
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p className={classes.gridHeading}>Final Receive Amount</p>
              <p className={classes.gridText}>
                {finalAmount} {selectedCoin}
              </p>
            </div>
          </div>
        </div>

        {hasInsufficientBalance && (
          <Text style={{ color: theme.palette.error.main }}>
            Insufficient {selectedCoin} balance. Available balance is{' '}
            {walletBalance} {selectedCoin}.
          </Text>
        )}

        <div style={{ margin: '10px' }}></div>

        <p className={classes.feeDisclaimer}>
          Network fee depends on the blockchain you pick. A 3% withdrawal fee
          will also be applied.
        </p>

        <GenericButton
          text={'Withdraw'}
          styles={{ marginTop: 'auto' }}
          onClick={withdrawCrypto}
          disabled={!isWalletAddrValid || !receiveAmountt || hasInsufficientBalance}
          loading={loadings}
        />
      </div>
      {showPopup && (
        <GeneralPopup
          message={popupMessage}
          onClose={handlePopupClose}
          width={popupMessage.length > 100 ? '600px' : '360px'}
        />
      )}
    </WithdrawCryptoLayout>
  );
};

export default WithdrawCryptoSelectCoin;
